import { renderForCriticalMoment } from "../dashHelper";
import general from "./staticDashboards/general";
import venta from "./staticDashboards/venta";
import postVenta from "./staticDashboards/postVenta";
import motosPostVenta from "./staticDashboards/motosPostVenta";
//import postVentaKpi from "./staticDashboards/postVentaKpi";

export default {
  title: 'Default Dashboard',
  description: 'Dashboard de perfil Default',
  backgroundClassName: (filters) => 'epsilon-hero-bg',
  widgets: (filters: FiltersUI, filtersData: Record<string, any>) => [
      ...general.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [29]),
        })),
      ...venta.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [13101]),
        })),  
      ...postVenta.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [13551]),
        })),  
      ...motosPostVenta.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [13554]),
        })), 
      /*
        ...postVentaKpi.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [-13551]),
        })),  
        */
    ],
} as DasboardConfig
